import { app } from '../../../../../bootstrap/core';
import { financePropertyComponent } from './financeProperty.component';
import './properties/ibanProperty/ibanProperty';

app.component('financeProperty', financePropertyComponent);
